// src/oura/tasks/refusals.ts
//
// What a refused add or delete says on the Tasks tab (ourteam-frontend#4751, backend
// #6621). The server's own sentence comes first. These sentences fill in a code that
// comes without one, and say which field a refusal belongs under.

export type RefusalField = "action" | "owner" | "status" | "target";

const FIELD_OF: Partial<Record<string, RefusalField>> = {
    empty_action: "action",
    bad_owner: "owner",
    bad_status: "status",
    bad_target: "target",
};

const WORDS: Record<string, string> = {
    empty_action: "Say what the task is.",
    bad_owner: "Pick an owner from the list.",
    bad_status: "Pick a status from the list.",
    bad_target: "Pick a real date for the target.",
    missing_idempotency_key: "The screen did not send an add key. Reload the page and try again.",
    forbidden: "Only Oura staff can change the tracker.",
    not_found: "That task is not on the tracker any more. Read the tracker again.",
    no_sheet: "This client has no tracker sheet linked.",
    no_tab: "That phase is not a tab of the client's sheet. Read the sheet again.",
    no_column: "The sheet is missing a column this change needs. Fix the sheet, then read it again.",
    sync_in_progress: "Try again in a moment.",
    sheet_unreadable: "Oura could not read the sheet. Try again shortly.",
    write_failed: "Google refused the change. Nothing was changed; try again.",
    write_unconfirmed: "Oura could not confirm the change reached the sheet. Read the sheet before you try again.",
    writes_off: "Changes to the tracker sheet are switched off on this server.",
    sheet_won: "The sheet changed this row first.",
};

/** The sentence to show for a refusal, and the field it sits under (if any). The server's message wins. */
export function describeRefusal(code: string | undefined, message: string): { field?: RefusalField; message: string } {
    const fallback = (code && WORDS[code]) || "That did not go through. Try again.";
    return { field: code ? FIELD_OF[code] : undefined, message: message || fallback };
}
